function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import FetchClient from "@dpdgroupuk/fetch-client";
import ElectronFetchClient from "./ElectronFetchClient";
import { LocalServiceFsApis, LocalServicePrinterApis } from "./routers";
import { EnvUtil, CookieUtil } from "../utils";

const getAppPort = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("appPort") || CookieUtil.get("appPort") || "2917";
};

class LocalApisClient {
  constructor(options = {}) {
    this._options = options;
    this._fetchClient = options.fetchClient;
    this.fs = new LocalServiceFsApis(this._fetchClient);
    this.printer = new LocalServicePrinterApis(this._fetchClient);
  }

  getApisBaseUrl() {
    return this.options.baseUrl;
  }

  async ping({
    timeout = 1000
  } = {}) {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await this._fetchClient.get({
      path: "/ping",
      options: {
        signal: controller.signal
      }
    });
    clearTimeout(id);
    return response;
  }

}

_defineProperty(LocalApisClient, "getAppPort", getAppPort);

export default LocalApisClient;
export const createLocalApisClient = ({
  handleElectronInjection,
  ...options
}) => {
  const port = options.port || getAppPort();
  const extendedOptions = {
    credentials: "include",
    baseUrl: EnvUtil.getLocalApisUrl(window.location, port),
    ...options
  };
  const fetchClient = handleElectronInjection && window.electronApisClient ? new ElectronFetchClient({ ...extendedOptions,
    electronApisClient: window.electronApisClient
  }) : new FetchClient(extendedOptions);
  return new LocalApisClient({ ...extendedOptions,
    fetchClient
  });
};